/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import AgChart from 'DesignSystem/AgChart/react'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/Report/ReportTable/Done/Content/Chart/Content"
  
}) {
let reportTableChartTitleValueData = fromData.useDataValue({ viewPath,
context: 'report_table',
path: 'chart.title',
})
let reportTableChartSeriesValueData = fromData.useDataValue({ viewPath,
context: 'report_table',
path: 'chart.series',
})
let reportTableChartAxesValueData = fromData.useDataValue({ viewPath,
context: 'report_table',
path: 'chart.axes',
})
let reportTableChartChartdataValueData = fromData.useDataValue({ viewPath,
context: 'report_table',
path: 'chart.chartData',
})
  return (<React.Fragment
>
<AgChart
  viewPath={`${viewPath}/AgChart`}
 data="report_table.chart.title"
 title={reportTableChartTitleValueData}
 data="report_table.chart.series"
 series={reportTableChartSeriesValueData}
 data="report_table.chart.axes"
 axes={reportTableChartAxesValueData}
 data="report_table.chart.chartData"
 chartData={reportTableChartChartdataValueData}
/>
{children}
</React.Fragment>)
}